import classNames from 'classnames';
import React, { useEffect } from 'react';
import { UiMegaphone } from '@vyaguta/vyaguta-icons/ui';
import { usePageVisibility } from 'react-page-visibility';

import MyTeam from './components/myTeam/MyTeam';
import { UpcomingEvents } from './components/upcomingEvents';
import { NoticeBoard } from './components/noticeBoard';
import DashboardCard from './components/DashboardCard';
import AllocationCard from './components/allocationCard/AllocationCard';

import * as mixpanel from 'services/mixPanel';

import { NOTICE_BOARD } from 'constants/routes';
import { mixPanelEvents } from 'constants/mixPanel';
import { EXCLUDED_DESIGNATION_FOR_WORKSHIFT, INCLUDED_COUNTRIES_FOR_WORKSHIFT } from 'constants/dashboard';
import type { Designation } from 'interface/designation';

import { useCurrentUser } from 'hooks/query/useUserInfo';
import useCurrentFiscalYear from 'hooks/useCurrentFiscalYear';

interface DashboardUser {
  id: number | string;
  country?: string;
  designation?: Designation;
}

interface DashboardProps {
  user: DashboardUser;
}

interface FiscalYearLike {
  startDate?: string;
  endDate?: string;
}

const Dashboard: React.FC<DashboardProps> = (props) => {
  useEffect(() => {
    window.document.title = 'Vyaguta';
  }, []);

  const isVisible = usePageVisibility();
  const currentFiscalYear: FiscalYearLike = useCurrentFiscalYear();
  const user = useCurrentUser() as DashboardUser;

  const hasUserInfo = Boolean(user?.id);

  const shouldShowWorkshift =
    INCLUDED_COUNTRIES_FOR_WORKSHIFT.includes(user?.country) &&
    !EXCLUDED_DESIGNATION_FOR_WORKSHIFT.includes(user?.designation?.name);

  useEffect(() => {
    const event = isVisible ? mixPanelEvents.view.dashboard : mixPanelEvents.switch.from.dashboard;

    mixpanel.trackEvent(event);
  }, [isVisible]);

  const gridClassname = !hasUserInfo || shouldShowWorkshift ? 'grid-rows-with-work-shift' : 'grid-rows';

  return (
    <div className="container dashboard">
      <div className={classNames(`dashboard__contents`, gridClassname)}>
        <AllocationCard userId={props.user.id} designation={props?.user?.designation} />

        {/* <DashboardCard className="actions" title="Attendance Information">
          <PendingActions userId={props.user.id} designation={props?.user?.designation} />
        </DashboardCard> */}

        {/* <DashboardCard className="full-scope-card dashboard__card leave-plan-card" title="Team's Leave Plan">
          <LeavePlanCard userId={props.user.id} />
        </DashboardCard> */}

        <UpcomingEvents currentFiscalYear={currentFiscalYear} />

        <DashboardCard className="full-scope-card dashboard__card notice-board d-flex flex-direction-column">
          <div className="dashboard__title d-flex justify-content-between notice-board__heading">
            <div className="d-flex align-items-center gap-px-12">
              <UiMegaphone size={20} />
              <span>Notice Board</span>
            </div>

            <a
              href={NOTICE_BOARD}
              rel="noopener noreferrer"
              className="d-flex gap-px-5 align-items-center notice-board__link"
            >
              <span>View All</span>
            </a>
          </div>
          <NoticeBoard />
        </DashboardCard>

        <div className="full-scope-card dashboard__card my-team">
          <MyTeam user={props?.user} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
